export enum RevisionType {
  ADD = 'ADD',
  MOD = 'MOD',
  DEL = 'DEL'
}

export const ALL_REVISION_TYPES: RevisionType[] = [
  RevisionType.ADD,
  RevisionType.MOD,
  RevisionType.DEL,
];